import React from "react";
import { withRouter } from "react-router-dom";
import { List, Avatar, Button, Icon } from "antd";

const styles = {
  textAlign: "left",
  border: "1px solid #c0c0c0",
  paddingTop: 0,
  paddingBottom: 0,
  position: "relative"
};
function PostsList({ posts, history, deleteBlogPost, addBlogToFacebook }) {
  return (
    <List
      itemLayout="horizontal"
      dataSource={posts}
      renderItem={(item, index) => (
        <List.Item
          actions={[
            <Button onClick={() => history.push(`/admin/blog/${item.id}`)}>
              <Icon type="form" />
            </Button>,
            <Button onClick={() => deleteBlogPost(item.id)} type="danger">
              <Icon type="delete" />
            </Button>
          ]}
          style={
            index === 0
              ? { ...styles }
              : { ...styles, borderTop: "1px solid #fff" }
          }
        >
          <List.Item.Meta
            style={{ alignItems: "center" }}
            avatar={
              <Avatar
                style={{ height: "70px", width: "70px", borderRadius: 0 }}
                size="large"
                shape="square"
                src={item.coverImage}
              />
            }
            title={<a href={`/admin/blog/${item.id}`}>{item.title}</a>}
            description={`${new Date(item.createTime).toLocaleDateString()}`}
          />
        </List.Item>
      )}
    />
  );
}

export default withRouter(PostsList);



// WEBPACK FOOTER //
// ./src/pages/Admin/BlogCollection/PostsList/component.js